import { createRootRoute, Outlet } from "@tanstack/react-router";
import { useDocumentTitle } from "../lib/title";

/** Every page, with the browser's title naming it (BUILD_SPEC §4.5). */
function Root() {
  useDocumentTitle();
  return (
    <div className="min-h-screen">
      <Outlet />
    </div>
  );
}

export const Route = createRootRoute({ component: Root });
